import React from 'react'

import { ReactComponent as SlideGlow } from '@/shared/assets/desktop/slideShowGlow.svg'
import { AdminSlides } from '../AdminSlides/AdminSlides'

import cls from './administration.module.scss'
import { useTranslation } from 'react-i18next'

export const EasyAdministration = () => {
    const { t } = useTranslation()
    return (
        <section className={cls.EasyAdministration}>
            <div className={cls.headline}>
                <h1>{t('easyadministration.easy')}</h1>
                <h2>{t('easyadministration.admin')}</h2>
                <p>{t('easyadministration.soft')}</p>
            </div>
            <article className={cls.sliderBox}>
                <AdminSlides />
                <SlideGlow className={cls.sliderGlow} />
            </article>
            <p className={cls.bottomText}>{t('easyadministration.manage')}</p>
        </section>
    )
}
